import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { MENU_ROUTE_PARAM, RouteParams } from './types.d';
import { getMenuItem, getSidebarItem, getMenuItemPath } from './routingHelpers';
import UsersManager from './UsersManager';
import Analytics from './Analytics';
import TeamsManager from './TeamsManager';
import TagManager from './TagManager';
import ChatsManager from './ChatsManager';
import CustomFieldsManager from './CustomFieldsManager';
import CannedMessagesManager from './CannedMessagesManager';
import VerifiedTemplatesManager from './VerifiedTemplatesManager';
import BusinessHours from './BusinessHours';
import SuggestedMessages from './SuggestedMessages';

const componentMap: Record<MENU_ROUTE_PARAM, React.ComponentType<unknown>> = {
  [MENU_ROUTE_PARAM.USERS]: UsersManager,
  [MENU_ROUTE_PARAM.TEAMS]: TeamsManager,
  [MENU_ROUTE_PARAM.CONVERSATIONS]: ChatsManager,
  [MENU_ROUTE_PARAM.CUSTOM_FIELDS]: CustomFieldsManager,
  [MENU_ROUTE_PARAM.CANNED_MESSAGES]: CannedMessagesManager,
  [MENU_ROUTE_PARAM.TAGS]: TagManager,
  [MENU_ROUTE_PARAM.TAGS_CONTACT]: TagManager,
  [MENU_ROUTE_PARAM.TAGS_ROOM]: TagManager,
  [MENU_ROUTE_PARAM.ANALYTICS]: Analytics,
  [MENU_ROUTE_PARAM.OVERVIEW]: Analytics,
  [MENU_ROUTE_PARAM.SALESDESK_PERFORMANCE]: Analytics,
  [MENU_ROUTE_PARAM.AGENTS_PERFORMANCE]: Analytics,
  [MENU_ROUTE_PARAM.CSAT]: Analytics,
  [MENU_ROUTE_PARAM.VERIFIED_TEMPLATES]: VerifiedTemplatesManager,
  [MENU_ROUTE_PARAM.CHAT_COPILOT_ASSISTANT]: SuggestedMessages,
  [MENU_ROUTE_PARAM.BUSINESS_HOURS]: BusinessHours,
};

const RenderItemComponent: React.FC = () => {
  const params = useParams<RouteParams>();
  const { section, subsection } = params;

  // Get the sidebar item to check if it has subItems
  const sidebarItem = getSidebarItem(params);

  // If the item has subItems but no subsection is specified, redirect to first subItem
  // Skip redirect if skipSubItemRedirect is true
  if (sidebarItem?.subItems?.length && !subsection && !sidebarItem.skipSubItemRedirect) {
    const firstSubItem = sidebarItem.subItems[0];
    const redirectPath = getMenuItemPath(section, firstSubItem.routeParam);
    return <Navigate to={redirectPath} replace />;
  }

  const menuItem = getMenuItem(params);

  if (!menuItem) {
    return null;
  }

  const Component = componentMap[menuItem.routeParam];

  return <Component />;
};

export default RenderItemComponent;
